import React, { useState } from 'react'
import { Container, Grid, Box, Typography } from '@mui/material'
import iconLogin from './../../assets/auth/illustration-dashboard.webp'
import FormLogin from '../../components/auth/FormLogin';
import FormOtpLogin from '../../components/auth/FormOtpLogin';
import { useTranslation } from 'react-i18next';

const Login = () => {
  const { t } = useTranslation();
  const [loginMode, setLoginMode] = useState('password'); // 'password' or 'otp'

  return (
    <>
      <Box
        sx={{
          minHeight: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: (theme) => theme.palette.mode === 'dark'
            ? 'radial-gradient(circle at top right, #1e293b, #020617)'
            : 'radial-gradient(circle at top right, #f8fafc, #f1f5f9)',
          py: 4
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={{ md: 8, xs: 4 }}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: { xs: 'none', md: 'flex' },
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <Typography variant="h2" mb={2} sx={{ fontWeight: 800, color: 'primary.main' }}>
                  {loginMode === 'password' ? t('auth.loginTitle') : t('otp.login_title')}
                </Typography>
                <Typography variant="h5" color="text.secondary" mb={4}>
                  {loginMode === 'password'
                    ? t('auth.loginSubtitle')
                    : t('otp.choose_method')}
                </Typography>
                <Box
                  component="img"
                  src={iconLogin}
                  alt="Login"
                  sx={{
                    maxWidth: '90%',
                    height: 'auto',
                    filter: 'drop-shadow(0px 20px 40px rgba(0,0,0,0.1))',
                    animation: 'float 6s ease-in-out infinite',
                    '@keyframes float': {
                      '0%': { transform: 'translateY(0px)' },
                      '50%': { transform: 'translateY(-20px)' },
                      '100%': { transform: 'translateY(0px)' },
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ width: '100%', maxWidth: 480, mx: 'auto' }}>
                <Box sx={{ display: { xs: 'block', md: 'none' }, textAlign: 'center', mb: 4 }}>
                  <Typography variant="h4" fontWeight={700} gutterBottom>
                    {loginMode === 'password' ? t('auth.signIn') : t('otp.login_title')}
                  </Typography>
                </Box>
                {loginMode === 'password' ? (
                  <FormLogin onSwitchToOtp={() => setLoginMode('otp')} />
                ) : (
                  <FormOtpLogin onBackToPassword={() => setLoginMode('password')} />
                )}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Login

